import { createAction } from '../types/utils';
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["CATEGORY_TREE_HYDRATE"] = "data::category_tree_hydrate";
    ActionTypes["CATEGORY_TREE_REQUEST_START"] = "data::category_tree_request_start";
    ActionTypes["CATEGORY_TREE_REQUEST_SUCCESS"] = "data::category_tree_request_success";
    ActionTypes["CATEGORY_TREE_REQUEST_FAIL"] = "data::category_tree_request_fail";
    ActionTypes["ARTICLE_PAGE_DATA_HYDRATE"] = "data::article_page_data_hydrate";
    ActionTypes["ARTICLE_PAGE_DATA_REQUEST_START"] = "data::article_page_data_start";
    ActionTypes["ARTICLE_PAGE_DATA_REQUEST_SUCCESS"] = "data::article_page_data_success";
    ActionTypes["ARTICLE_PAGE_DATA_REQUEST_FAIL"] = "data::article_page_data_fail";
    ActionTypes["CATEGORY_PAGE_DATA_HYDRATE"] = "data::category_page_data_hydrate";
    ActionTypes["CATEGORY_PAGE_DATA_REQUEST_START"] = "data::category_page_data_start";
    ActionTypes["CATEGORY_PAGE_DATA_REQUEST_SUCCESS"] = "data::category_page_data_success";
    ActionTypes["CATEGORY_PAGE_DATA_REQUEST_FAIL"] = "data::category_page_data_fail";
})(ActionTypes || (ActionTypes = {}));
export const Actions = {
    categoryTreeHydrate: (payload) => createAction(ActionTypes.CATEGORY_TREE_HYDRATE, payload),
    categoryTreeRequestStart: () => createAction(ActionTypes.CATEGORY_TREE_REQUEST_START),
    categoryTreeRequestSuccess: (payload) => createAction(ActionTypes.CATEGORY_TREE_REQUEST_SUCCESS, payload),
    categoryTreeRequestFail: () => createAction(ActionTypes.CATEGORY_TREE_REQUEST_FAIL),
    articlePageDataHydrate: (payload) => createAction(ActionTypes.ARTICLE_PAGE_DATA_HYDRATE, payload),
    articlePageDataRequestStart: (payload) => createAction(ActionTypes.ARTICLE_PAGE_DATA_REQUEST_START, payload),
    articlePageDataRequestSuccess: (payload) => createAction(ActionTypes.ARTICLE_PAGE_DATA_REQUEST_SUCCESS, payload),
    articlePageDataRequestFail: (payload) => createAction(ActionTypes.ARTICLE_PAGE_DATA_REQUEST_FAIL, payload),
    categoryPageDataHydrate: (payload) => createAction(ActionTypes.CATEGORY_PAGE_DATA_HYDRATE, payload),
    categoryPageDataRequestStart: (payload) => createAction(ActionTypes.CATEGORY_PAGE_DATA_REQUEST_START, payload),
    categoryPageDataRequestSuccess: (payload) => createAction(ActionTypes.CATEGORY_PAGE_DATA_REQUEST_SUCCESS, payload),
    categoryPageDataRequestFail: (payload) => createAction(ActionTypes.CATEGORY_PAGE_DATA_REQUEST_FAIL, payload),
};
//# sourceMappingURL=data.js.map